import {
  Autocomplete,
  Checkbox,
  Grid,
  InputLabel,
  TextField,
  Typography,
  Button,
  CircularProgress,
  MenuItem,
} from '@mui/material';
import { MyLocation as MyLocationIcon } from '@mui/icons-material';
import React, { useState } from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import VehicalChecklistTable from './VehicalChecklistTable';
import AdditionalInfoSection from './AdditionalInfoSection';
import { EmployeeNameField, DateTimeField } from './SharedFormFields';
import { ALL_TASK_OPTIONS } from './GeneralTaskForm';

const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};

const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': { fontSize: '0.82rem', fontWeight: 500 },
    },
  },
};

const GenTaskDrivingForm = ({
  data,
  setData,
  files,
  setUploadedFiles,
  checklistOptions,
  vehicalOption,
  trailerOptions,
  checkListData,
  handleCheckListEdit,
  isAdd = false,
}) => {
  const [locLoading, setLocLoading] = useState(false);
  const [locError, setLocError] = useState('');

  const handleChangeData = (name, value) => {
    setData(prev => ({ ...prev, [name]: value }));
  };

  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      setLocError('Geolocation not supported by your browser.');
      return;
    }
    setLocLoading(true);
    setLocError('');
    navigator.geolocation.getCurrentPosition(
      pos => {
        handleChangeData('geolocationLatitude', pos.coords.latitude);
        handleChangeData('geolocationLongitude', pos.coords.longitude);
        setLocLoading(false);
      },
      () => {
        setLocError('Unable to retrieve location. Please allow location access.');
        setLocLoading(false);
      },
    );
  };

  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': { fontSize: '0.825rem' },
        '& .MuiInputBase-root': { fontSize: '0.825rem !important' },
      }}>
      {/* Shared fields — behave differently based on isAdd */}
      <EmployeeNameField value={data['employeeName']} onChange={handleChangeData} />
      <DateTimeField value={data['dateAndTime']} onChange={handleChangeData} />

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Vehicle
        </InputLabel>
        <Autocomplete
          size="small"
          disablePortal
          value={data['vehicle'] || null}
          options={vehicalOption}
          onChange={(_, newValue) => handleChangeData('vehicle', newValue || '')}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{ ...autoCompleteSlotProps }}
        />
      </Grid>

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Trailer
        </InputLabel>
        <Autocomplete
          size="small"
          disablePortal
          value={data['trailer'] || null}
          options={trailerOptions}
          onChange={(_, newValue) => handleChangeData('trailer', newValue || '')}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{ ...autoCompleteSlotProps }}
        />
      </Grid>

      <InputFields
        label="Mileage (Odometer Reading in KM)"
        name="mileageReadingKM"
        required
        value={data['mileageReadingKM']}
        textFieldType="number"
        width={4}
        handleIpChange={handleChangeData}
      />

      {/* Geolocation — Add only: optional one-click capture */}
      {isAdd && (
        <Grid item xs={12}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <Button
              type="button"
              size="small"
              variant="outlined"
              startIcon={locLoading ? <CircularProgress size={14} /> : <MyLocationIcon />}
              onClick={handleGetLocation}
              disabled={locLoading}>
              {locLoading ? 'Getting Location...' : 'Capture My Location (Optional)'}
            </Button>
            {data['geolocationLatitude'] && data['geolocationLongitude'] && (
              <Typography variant="caption" color="text.secondary">
                📍 {parseFloat(data['geolocationLatitude']).toFixed(5)},{' '}
                {parseFloat(data['geolocationLongitude']).toFixed(5)}
              </Typography>
            )}
            {locError && (
              <Typography variant="caption" color="error">
                {locError}
              </Typography>
            )}
          </div>
        </Grid>
      )}

      <VehicalChecklistTable
        checkListOptions={checklistOptions}
        checklistData={checkListData}
        handleCheckListDataEdit={handleCheckListEdit}
      />

      <Grid item xs={12} sx={{ alignContent: 'end' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingInline: '1rem' }}>
          <Typography variant="subtitle2">
            I confirm that I have fully completed the Vehicle Check List and all issues have been noted above *
          </Typography>
          <Checkbox
            required
            checked={data['vehicleCheckListCompleted'] && data['vehicleCheckListCompleted'] == '1'}
            onChange={e => handleChangeData('vehicleCheckListCompleted', e.target.checked ? '1' : '0')}
          />
        </div>
      </Grid>

      <AdditionalInfoSection data={data} handleChange={handleChangeData} />
    </Grid>
  );
};

export default GenTaskDrivingForm;
